import React from "react";

export function StatusBadge({ status }) {
  const map = {
    "Booked": "bg-blue-100 text-blue-800",
    "Dispatched": "bg-amber-100 text-amber-800",
    "In Transit": "bg-indigo-100 text-indigo-800",
    "Arrived At Hub": "bg-cyan-100 text-cyan-800",
    "Out For Delivery": "bg-orange-100 text-orange-800",
    "Delivered": "bg-emerald-100 text-emerald-800",
    "Cancelled": "bg-red-100 text-red-800",
  };
  return <span data-testid={`status-${status}`} className={`inline-flex px-2 py-0.5 rounded-md text-xs font-medium ${map[status] || "bg-slate-100 text-slate-700"}`}>{status}</span>;
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <h1 className="text-2xl font-bold text-slate-900" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex gap-2">{actions}</div>
    </div>
  );
}

export function Btn({ children, variant="primary", ...p }) {
  const styles = {
    primary: "lt-btn-primary",
    secondary: "lt-btn-secondary",
    ghost: "bg-slate-100 text-slate-700 hover:bg-slate-200",
    danger: "bg-red-600 hover:bg-red-700 text-white",
  };
  return (
    <button {...p} className={`px-3.5 py-2 rounded-md text-sm font-medium transition ${styles[variant]} ${p.className||""}`}>
      {children}
    </button>
  );
}

export function Field({ label, children, className="" }) {
  return (
    <label className={`block ${className}`}>
      <span className="text-xs font-medium text-slate-600 block mb-1">{label}</span>
      {children}
    </label>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 ${props.className||""}`} />;
}

export function Select({ children, ...p }) {
  return <select {...p} className={`w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 bg-white ${p.className||""}`}>{children}</select>;
}

export function Textarea(p) {
  return <textarea {...p} className={`w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 ${p.className||""}`} />;
}

export function Modal({ open, onClose, title, children, size="md" }) {
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const sizes = { sm: "max-w-md", md: "max-w-2xl", lg: "max-w-4xl", xl: "max-w-6xl" };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 overflow-y-auto" onClick={onClose}>
      <div className={`bg-white rounded-lg shadow-xl w-full ${sizes[size]} my-8`} onClick={e=>e.stopPropagation()} data-testid="modal">
        <div className="px-5 py-3 border-b flex items-center justify-between">
          <div className="font-semibold text-slate-900">{title}</div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="modal-close">✕</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function EmptyState({ title="No data yet", subtitle, action }) {
  return (
    <div className="lt-card p-12 text-center">
      <div className="text-slate-400 text-5xl mb-3">∅</div>
      <h3 className="font-semibold text-slate-700">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
